// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from '@leagueplatform/genesis-core';
import '../manrope.font.css';

export const medibankMyHealthTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: '#FFFFFFFF',
        secondary: '#F9FAFBFF',
        tertiary: '#FEF3EBFF',
      },
      card: {
        primary: '#FFFFFFFF',
        secondary: '#FFFFFFFF',
        disabled: '#EAECF0FF',
      },
      screenHeader: { background: '#FEF3EBFF' },
      skeleton: {
        shimmer: {
          background: '#D0D5DDFF',
          overlay:
            'linear-gradient(90.0deg, #FFFFFFFF 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
        },
      },
    },
    onSurface: {
      text: {
        primary: '#101828FF',
        subdued: '#475467FF',
        reversed: '#FFFFFFFF',
        critical: '#B42318FF',
        success: '#067647FF',
        warning: '#B54708FF',
      },
      border: { subdued: '#EAECF0FF', default: '#D0D5DDFF', card: '#E9EAEBFF' },
      icon: { primary: '#475467FF' },
    },
    interactive: {
      action: {
        primary: '#475467FF',
        hovered: '#344054FF',
        pressed: '#344054FF',
        subdued: '#667085FF',
        disabled: '#D0D5DDFF',
      },
      icon: { default: '#FFFFFFFF', disabled: '#D0D5DDFF' },
      background: {
        default: '#FFFFFFFF',
        disabled: '#F9FAFBFF',
        hovered: '#FFFFFFFF',
        pressed: '#FFFFFFFF',
      },
      border: {
        default: '#D0D5DDFF',
        hovered: '#D0D5DDFF',
        disabled: '#D0D5DDFF',
        critical: { default: '#B42318FF' },
      },
      focus: { inner: '#F46E15FF', outer: '#F46E15FF' },
    },
    critical: {
      background: { subdued: '#FFFBFAFF', secondary: '#FFFFFFFF' },
      border: { default: '#FDA29BFF' },
      icon: '#D92D20FF',
    },
    warning: {
      background: { subdued: '#FFFCF5FF', secondary: '#FFFFFFFF' },
      border: { default: '#FEC84BFF' },
      icon: '#DC6803FF',
    },
    success: {
      background: { subdued: '#F6FEF9FF', secondary: '#FFFFFFFF' },
      border: { default: '#75E0A7FF' },
      icon: '#079455FF',
    },
    highlight: {
      background: { subdued: '#C8E7FFFF', secondary: '#FFFFFFFF' },
      border: { default: '#026AA2FF' },
      icon: '#026AA2FF',
    },
    decorative: {
      brand: {
        primary: {
          darkest: '#C35309FF',
          dark: '#EA640BFF',
          default: '#F47721FF',
          bright: '#F9AB77FF',
          brightest: '#FDDBC4FF',
          pastel: '#FEF3EBFF',
        },
        secondary: {
          darkest: '#164C63FF',
          dark: '#164C63FF',
          default: '#026AA2FF',
          bright: '#5FAFEFFF',
          brightest: '#F9FAFBFF',
          pastel: '#C8E7FFFF',
        },
        tertiary: {
          darkest: '#651236FF',
          dark: '#B7005DFF',
          default: '#E492ABFF',
          bright: '#F6BECDFF',
          brightest: '#FFDBE5FF',
          pastel: '#FFE9EFFF',
        },
      },
    },
    primary: {
      background: {
        default: '#F46E15FF',
        hovered: '#F46E15FF',
        pressed: '#F46E15FF',
        critical: {
          default: '#D92D20FF',
          hovered: '#B42318FF',
          pressed: '#B42318FF',
        },
      },
      text: { default: '#FFFFFFFF', critical: { default: '#FFFFFFFF' } },
    },
    secondary: {
      background: {
        default: '#FFFFFFFF',
        hovered: '#F9FAFBFF',
        pressed: '#F9FAFBFF',
      },
      text: { default: '#344054FF', hovered: '#1D2939FF' },
      border: { default: '#D0D5DDFF' },
    },
    tertiary: {
      background: {
        default: '#21212100',
        hovered: '#F9FAFBFF',
        pressed: '#F9FAFBFF',
      },
      text: { default: '#475467FF', hovered: '#344054FF' },
      border: { default: '#21212100' },
    },
    input: {
      border: {
        success: '#067647FF',
        warning: '#B54708FF',
        default: '#D0D5DDFF',
        hovered: '#D0D5DDFF',
        disabled: '#D0D5DDFF',
        critical: '#B42318FF',
      },
      background: {
        default: '#FFFFFFFF',
        disabled: '#F9FAFBFF',
        hovered: '#FFFFFFFF',
        pressed: '#FFFFFFFF',
      },
    },
    dataViz: {
      interface: { track: { border: '#EAECF0FF', background: '#EAECF0FF' } },
      singleColor: { brand: '#F47721FF', neutral: '#EAECF0FF' },
      status: {
        critical: '#D92D20FF',
        warning: '#FEC84BFF',
        success: '#079455FF',
      },
      categorical: {
        one: '#F47721FF',
        two: '#026AA2FF',
        three: '#164C63FF',
        four: '#079455FF',
        five: '#D92D20FF',
        six: '#FEC84BFF',
      },
    },
    tag: {
      neutral: {
        background: { bold: '#3B3B3BFF', subdued: '#E9E9E9FF' },
        border: { bold: '#3B3B3BFF', subdued: '#E9E9E9FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      one: {
        background: { bold: '#501CD2FF', subdued: '#EDEAF5FF' },
        border: { bold: '#501CD2FF', subdued: '#EDEAF5FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      two: {
        background: { bold: '#135D03FF', subdued: '#DEEADCFF' },
        border: { bold: '#135D03FF', subdued: '#DEEADCFF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      three: {
        background: { bold: '#994000FF', subdued: '#F2EEE6FF' },
        border: { bold: '#994000FF', subdued: '#F2EEE6FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      four: {
        background: { bold: '#870644FF', subdued: '#F2E1F0FF' },
        border: { bold: '#870644FF', subdued: '#F2E1F0FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      success: {
        background: { bold: '#008A09FF', subdued: '#E3F7F0FF' },
        border: { bold: '#008A09FF', subdued: '#E3F7F0FF' },
        text: { bold: '#FFFFFFFF', subdued: '#02692BFF' },
      },
      warning: {
        background: { bold: '#B85B0FFF', subdued: '#FAE8D6FF' },
        border: { bold: '#B85B0FFF', subdued: '#FAE8D6FF' },
        text: { bold: '#FFFFFFFF', subdued: '#9F3703FF' },
      },
      critical: {
        background: { bold: '#DD0E0EFF', subdued: '#F9E1E2FF' },
        border: { bold: '#DD0E0EFF', subdued: '#F9E1E2FF' },
        text: { bold: '#FFFFFFFF', subdued: '#BB1111FF' },
      },
      informational: {
        background: { bold: '#2E5CDFFF', subdued: '#E8F8FFFF' },
        border: { bold: '#2E5CDFFF', subdued: '#E8F8FFFF' },
        text: { bold: '#FFFFFFFF', subdued: '#225ECEFF' },
      },
    },
  },
  shadows: {
    card: { x: 0, y: 1, blur: 2, spread: 0, color: '#1018280D' },
    dropdown: { x: 0, y: 4, blur: 6, spread: -2, color: '#10182808' },
  },
  typography: {
    headingOne: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 44,
      fontSize: 36,
      letterSpacing: -2,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingTwo: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 44,
      fontSize: 30,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingThree: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 38,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingFour: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleOne: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleTwo: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOne: {
      fontFamily: 'Manrope',
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOneSecondary: {
      fontFamily: 'Manrope',
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwo: {
      fontFamily: 'Manrope',
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwoSecondary: {
      fontFamily: 'Manrope',
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonOne: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonTwo: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    label: {
      fontFamily: 'Manrope',
      fontWeight: 500,
      lineHeight: 18,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    overline: {
      fontFamily: 'Manrope',
      fontWeight: 600,
      lineHeight: 18,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'capitalize',
      textDecoration: 'none',
    },
    caption: {
      fontFamily: 'Manrope',
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    tab: {
      fontFamily: 'Manrope',
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
    eighth: 2,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 6,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 4,
    inputField: 4,
    card: 4,
    progressBar: 9999,
    tags: 4,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2.25,
      headingTwo: 1.875,
      headingThree: 1.5,
      headingFour: 1.5,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.875,
    },
    lineHeights: {
      headingOne: 2.75,
      headingTwo: 2.75,
      headingThree: 2.375,
      headingFour: 2,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1.125,
      overline: 1.125,
      caption: 1,
      tab: 1.25,
    },
    baseSize: 16,
  },
  fonts: { headings: 'Manrope', body: 'Manrope' },
  transitions: { defaultTime: '200ms' },
};
